import type { PreloadedQuery } from 'react-relay';
import { createAri } from '@jira/platform__utils-ari/src/index.tsx';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import QUERY, {
	type CustomFiltersLoaderQuery,
} from './__generated__/CustomFiltersLoaderQuery.graphql';

const RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS =
	'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';

export const customFiltersResource: RouteResource<
	PreloadedQuery<CustomFiltersLoaderQuery, Record<string, unknown>>
> = createRelayResource<CustomFiltersLoaderQuery>({
	type: RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			boardId: createAri({
				resourceOwner: 'jira-software',
				cloudId: tenantContext.cloudId,
				resourceType: 'board',
				resourceId: String(match.params.boardId),
			}),
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
